import React, { useState } from 'react';
import { BookOpen, FileSignature, GraduationCap, ScrollText, Building2, ListChecks } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import PiecesJointes from '../../components/PiecesJointes';

// Documents de référence de la crèche, classés par onglet et par structure.
const ONGLETS = [
  { key: 'ref_contrat', label: 'Contrat', icon: FileSignature, desc: "Contrat d'accueil type / modèles de contrat." },
  { key: 'ref_projet', label: 'Projet pédagogique', icon: GraduationCap, desc: 'Projet éducatif et pédagogique de la structure.' },
  { key: 'ref_reglement', label: 'Règlement de fonctionnement', icon: ScrollText, desc: 'Règlement de fonctionnement de la structure.' },
  { key: 'ref_process', label: "Process d'inscription", icon: ListChecks, desc: "Document « La suite de votre inscription » joint aux devis (case « Envoyer le process »). Remplacez le fichier ici pour mettre à jour partout." },
];

export default function RessourcesDocsPage() {
  const { structures } = useApp();
  const [tab, setTab] = useState(ONGLETS[0].key);
  // 0 = commun à toutes les structures ; sinon structure_id
  const [structureId, setStructureId] = useState(0);

  const onglet = ONGLETS.find(o => o.key === tab) || ONGLETS[0];

  return (
    <div className="max-w-4xl">
      <div className="mb-4">
        <h1 className="font-serif text-[28px] leading-tight text-navy-900 flex items-center gap-2">
          <BookOpen size={24} className="text-gold-600" /> Documents de référence
        </h1>
        <div className="w-12 h-0.5 bg-gold-400 rounded-full mt-2 mb-2.5" />
        <p className="text-navy-400 text-[13.5px]">Contrat type, projet pédagogique et règlement de fonctionnement — communs ou par structure.</p>
      </div>

      {/* Portée : commun ou structure */}
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <span className="text-[12px] text-navy-400 flex items-center gap-1"><Building2 size={13} /> Portée :</span>
        <button onClick={() => setStructureId(0)}
          className={`px-3 py-1.5 rounded-lg text-[13px] border transition-colors ${structureId === 0 ? 'bg-navy-800 text-white border-navy-800' : 'bg-white text-navy-600 border-cream-300 hover:border-navy-300'}`}>
          Commun
        </button>
        {structures.map(s => (
          <button key={s.id} onClick={() => setStructureId(s.id)}
            className={`px-3 py-1.5 rounded-lg text-[13px] border transition-colors ${String(structureId) === String(s.id) ? 'bg-navy-800 text-white border-navy-800' : 'bg-white text-navy-600 border-cream-300 hover:border-navy-300'}`}>
            {s.nom}
          </button>
        ))}
      </div>

      {/* Onglets */}
      <div className="flex flex-wrap gap-1 border-b border-cream-300 mb-4">
        {ONGLETS.map(o => (
          <button key={o.key} onClick={() => setTab(o.key)}
            className={`inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors ${tab === o.key ? 'border-gold-500 text-navy-900' : 'border-transparent text-navy-400 hover:text-navy-700'}`}>
            <o.icon size={15} /> {o.label}
          </button>
        ))}
      </div>

      <p className="text-[12.5px] text-navy-400 mb-3">{onglet.desc}</p>

      {/* Bibliothèque de documents pour l'onglet + la portée choisis */}
      <PiecesJointes
        key={`${tab}-${structureId}`}
        entiteType={tab}
        entiteId={structureId}
        title={onglet.label}
        library={false}
      />
    </div>
  );
}
